<template>
  <div class="">
    <div class="head-title">企业信息设置</div>
    <el-collapse style="margin-bottom: 2rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>设置企业名称、联系电话、企业地址、企业Logo，并在首页展示。</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <!-- form表单展示 -->
      <el-form
        class="form-show"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="15rem"
        status-icon
      >
        <el-form-item label="企业名称:" prop="name">
          <el-input
            clearable
            v-model="ruleForm.name"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" prop="tel">
          <el-input
            clearable
            v-model="ruleForm.tel"
            placeholder="请输入企业联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业详细地址:" prop="address">
          <el-input
            clearable
            v-model="ruleForm.address"
            placeholder="请输入企业详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业logo:" style="postion: relation">
          <el-upload
            :action="action"
            ref="upload"
            accept="image/png,image/jpg,image/jpeg"
            list-type="picture"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :multiple="false"
            :limit="1"
          >
            <el-button
              size="small"
              :loading="btnLoading"
              :disabled="btnLoading"
              type="primary"
              >点击上传</el-button
            >
            <div slot="tip" class="el-upload__tip">
              上传企业logo 不能超过10M
            </div>
          </el-upload>
          <template v-if="imageUrl">
            <el-image
              v-if="imageUrl != 'https://api.weijub.com/'"
              :src="imageUrl"
              class="avatar"
              :fit="scale - down"
              :preview-src-list="imageUrl"
            />
          </template>
        </el-form-item>
        <el-form-item label="到期时间:">
          <div class="expired">{{ user_pasttime }}</div>
        </el-form-item>
        <el-form-item label="企业权限:">
          <div class="expired">{{ priveName }}</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >完成</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
export default {
  inject: ["reload"],
  data() {
    // 邮箱输入的正则匹配
    var emailCheck = (rule, value, callback) => {
      if (
        !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
          value
        )
      ) {
        return callback("邮箱输入有误，请重填");
      }
      return callback();
    };
    return {
      tooken: "",
      account_id: "",
      phone: "",
      // 二级联动的数据
      form: {
        province: "",
        city: "",
      },
      // 请求基础路径
      baseURL: this.axios.defaults.baseURL,
      // 上传路径
      action: "",
      // 上传图片地址
      imageUrl: "",
      // 用户上传logo
      dialogImageUrl: "",
      dialogVisible: false,
      username: {},
      title: {},
      logoUrl: "",
      logoReqUrl: "",
      ruleForm: {
        name: "",
        tel: "",
        address: "",
      },
      options: provinceAndCityData,
      selectedOptions: [],
      rules: {
        name: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            trigger: "blur",
            message: "请输入企业联系电话",
          },
        ],
        address: [
          {
            required: true,
            trigger: "blur",
            message: "请输入企业详细地址",
          },
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            validator: emailCheck,
          },
        ],
      },
      btnLoading: false,
      user_pasttime: "",
      priveName: ""
    };
  },
  methods: {
    // 文件移除
    handleRemove() {},
    handlePictureCardPreview() {},
    // 文件上传成功
    handleSuccess(response, file, fileList) {
      this.logoReqUrl = response.data.url;
      this.$message({
        message: response.msg,
        type: "success",
      });
      console.log(response.data.url);
      this.imageUrl = response.data.url;
      this.btnLoading = false;
    },
    // 二级联动数据发生变化
    handleChang(value) {
      //赋值省
      this.form.province = CodeToText[value[0]];
      //赋值市
      this.form.city = CodeToText[value[1]];
    },
    // 添加或修改企业信息
    editOrAdd() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/editAddAccountInfo`,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          account_name: this.ruleForm.name,
          enterprisePhoto: this.logoReqUrl,
          phone: this.ruleForm.tel,
          address: this.ruleForm.address,
        }),
      })
        .then((res) => {
          this.$message({
            message: "企业信息修改成功",
            type: "success",
          });
          this.tooken.enterprisePhoto = this.logoReqUrl;
          this.tooken.address = this.ruleForm.address;
          this.tooken.account_name = this.ruleForm.name;
          localStroage.setItem("storuser", JSON.stringify(this.tooken));
          this.reload();
        })
        .catch((err) => {});
    },
    // 表单验证提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$message({
          //   message: "提交成功",
          //   type: "success"
          // });
        } else {
          return false;
        }
      });
      this.editOrAdd();
    },
    // 判断是本地上传是、还是云上传
    judgeUploadMethod() {
      this.action = `${this.baseURL}/home/Alioss/uploadTotal?usertoken=${this.tooken.usertoken}`;
    },
    // 文件上传之前，对文件大小进行判断
    beforeAvatarUpload(file) {
      if (!file) {
        this.$message.error("请选择要上传的logo");
      }
      let isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      this.btnLoading = true;
    },
    // 渲染企业信息
    renderInformation(res) {
      this.ruleForm.name = res.account_name;
      this.ruleForm.tel = res.phone;
      this.ruleForm.address = res.address;
      this.imageUrl = res.enterprisePhoto;
      this.imageUrl = this.imageUrl.replace(/\\/g, "/");
    },
    // 获取token值
    getToken() {
      if (window.sessionStorage.getItem("title")) {
        let title = JSON.parse(window.sessionStorage.getItem("title"));
        this.title = title;
        var a = document.title;
        document.title = title[0].website + "-" + a;
      }
      if (window.localStorage.getItem("storuser")) {
        let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
        this.tooken = userinfo;
      }
    },
  },
  created() {
    // 获取token值
    this.getToken();
    // 判断upload上传方式
    this.judgeUploadMethod();
    // let localStroage = window.localStorage;
    // this.account_id = localStroage.getItem("account_id");
    // this.phone = localStroage.getItem("phone");
    // // 获取企业信息
    // this.axios({
    //   method: "post",
    //   url: `${this.baseURL}/home/AccountInfo/getAccountInfo`,
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //   data: qs.stringify({
    //     usertoken: this.tooken.usertoken,
    //     account_id: this.tooken.account_id,
    //     phone: this.tooken.phone,
    //   }),
    // })
    //   .then((res) => {
    //     this.renderInformation(res.data.data);
    //   })
    //   .catch((err) => {});
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }

    // 获取企业信息
    this.axios({
      method: "post",
      url: `${this.baseURL}/home/AccountInfo/getAccountInfo`,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify({
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
      }),
    })
      .then((res) => {
        this.user_pasttime = res.data.data.user_pasttime;
        this.priveName = res.data.data.priveName;
        this.renderInformation(res.data.data);
      })
      .catch((err) => {});
  },
};
</script>
<style lang="less">
// .form-show {
//   .el-form-item__content,
//   .el-input__inner {
//     width: 36rem !important;
//   }
// }
</style>
<style scoped>
.avatar {
  width: 6rem;
  height: 6rem;
}
.expired {
  color: #999;
}
</style>